module.exports = __webpack_public_path__ + "static/media/YM82_1.c86f5dee.jpg";